import { render, staticRenderFns } from "./EntrepreneurshipTasks.vue?vue&type=template&id=5cbcdb9e"
import script from "./EntrepreneurshipTasks.vue?vue&type=script&lang=js"
export * from "./EntrepreneurshipTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports